import actions from './actions';
import reducer from './reducer';

const registration = {
    actions,
    reducer,
    name: 'registration',
};

export default registration; 